import * as generic from '@/store/generic/mutations/result-status.js'

export function clearError(state, payload) {
  generic.clearError(state, payload)
}

export function setError(state, payload) {
  generic.setError(state, payload)
}

export function setSuccess(state, payload) {
  generic.setSuccess(state, payload)
}

export function setProcessing(state, payload) {
  generic.setProcessing(state, payload)
}

export function setPeriod(state, payload) {
  state.period = payload
}

export function setPeriods(state, payload) {
  state.periods = payload
}

export function delPeriod(state, payload) {
  const periods = state.periods.filter(res => res.id !== payload.id)
  state.periods = periods || []
}

export function setDegree(state, payload) {
  state.degree = payload
}

export function setDegrees(state, payload) {
  state.degrees = payload
}

export function setDegreeOptions(state, payload) {
  state.degreeOptions = payload
}

export function delDegree(state, payload) {
  const degrees = state.degrees.filter(res => res.id !== payload.id)
  state.degrees = degrees || []
}

export function setProject(state, payload) {
  state.project = payload
}

export function setProjects(state, payload) {
  state.projects = payload
}

export function setProjectOptions(state, payload) {
  state.projectOptions = payload
}

export function delProject(state, payload) {
  const projects = state.projects.filter(res => res.id !== payload.id)
  state.projects = projects || []
}

export function setCampus(state, payload) {
  state.campus = payload
}

export function setCampuses(state, payload) {
  state.campuses = payload
}

export function setCampusOptions(state, payload) {
  state.campusOptions = payload
}

export function delCampus(state, payload) {
  const campuses = state.campuses.filter(res => res.id !== payload.id)
  state.campuses = campuses || []
}

export function setFaculty(state, payload) {
  state.faculty = payload
}

export function setFaculties(state, payload) {
  state.faculties = payload
}

export function delFaculty(state, payload) {
  const faculties = state.faculties.filter(res => res.id !== payload.id)
  state.faculties = faculties || []
}

export function setCurriculum(state, payload) {
  state.curriculum = payload
}

export function setCurriculums(state, payload) {
  state.curriculums = payload
}

export function delCurriculum(state, payload) {
  const curriculums = state.curriculums.filter(res => res.id !== payload.id)
  state.curriculums = curriculums || []
}

export function setCurriculumExternal(state, payload) {
  state.curriculumExternal = payload
}

export function setCurriculumExternals(state, payload) {
  state.curriculumExternals = payload
}

export function setCurriculumOptions(state, payload) {
  state.curriculumsOptions = payload
}

export function delCurriculumExternal(state, payload) {
  const curriculumExternals = state.curriculumExternals.filter(res => res.id !== payload.id)
  state.curriculumExternals = curriculumExternals || []
}

export function setPrefix(state, payload) {
  state.prefix = payload
}

export function setPrefixOptions(state, payload) {
  state.prefixOptions = payload
}

export function setSource(state, payload) {
  state.source = payload
}

export function setSources(state, payload) {
  state.sources = payload
}

export function delSource(state, payload) {
  const sources = state.sources.filter(res => res.id !== payload.id)
  state.sources = sources || []
}

export function setPrefixes(state, payload) {
  state.prefixes = payload
}

export function delPrefix(state, payload) {
  const prefixes = state.prefixes.filter(res => res.id !== payload.id)
  state.prefixes = prefixes || []
}

export function setRelationship(state, payload) {
  state.relationship = payload
}

export function setRelationshipOptions(state, payload) {
  state.relationshipOptions = payload
}

export function setRelationships(state, payload) {
  state.relationships = payload
}

export function delRelationship(state, payload) {
  const relationships = state.relationships.filter(res => res.id !== payload.id)
  state.relationships = relationships || []
}

export function setNationality(state, payload) {
  state.nationality = payload
}

export function setNationalities(state, payload) {
  state.nationalities = payload
}

export function delNationality(state, payload) {
  const nationalities = state.nationalities.filter(res => res.id !== payload.id)
  state.nationalities = nationalities || []
}

export function setRace(state, payload) {
  state.race = payload
}

export function setRaces(state, payload) {
  state.races = payload
}

export function delRace(state, payload) {
  const races = state.races.filter(res => res.id !== payload.id)
  state.races = races || []
}

export function setReligion(state, payload) {
  state.religion = payload
}

export function setReligions(state, payload) {
  state.religions = payload
}

export function delReligion(state, payload) {
  const religions = state.religions.filter(res => res.id !== payload.id)
  state.religions = religions || []
}

export function setOccupation(state, payload) {
  state.occupation = payload
}

export function setOccupations(state, payload) {
  state.occupations = payload
}

export function delOccupation(state, payload) {
  const occupations = state.occupations.filter(res => res.id !== payload.id)
  state.occupations = occupations || []
}

export function setSigner(state, payload) {
  state.signer = payload
}

export function setSigners(state, payload) {
  state.signers = payload
}

export function setSignerOptions(state, payload) {
  state.signerOptions = payload
}

export function delSigner(state, payload) {
  const signers = state.signers.filter(res => res.id !== payload.id)
  state.signers = signers || []
}

export function setNotificationTemplate(state, payload) {
  state.notificationTemplate = payload
}

export function setNotificationTemplates(state, payload) {
  state.notificationTemplates = payload
}

export function setNotificationTemplateOptions(state, payload) {
  state.notificationTemplateOptions = payload
}

export function delNotificationTemplate(state, payload) {
  const notificationTemplates = state.notificationTemplates.filter(res => res.id !== payload.id)
  state.notificationTemplates = notificationTemplates || []
}

export function setPaymentFilters(state, payload) {
  state.paymentFilters = {
    project: payload.project,
    loanType: payload.loanType,
    curriculum: payload.curriculum,
    contractNo: payload.contractNo,
    contractName: payload.contractName,
    overDueType: payload.overDueType
  }
}

export function setTransactionFilters(state, payload) {
  state.transactionFilters = {
    project: payload.project,
    loanType: payload.loanType,
    curriculum: payload.curriculum,
    contractNo: payload.contractNo,
    contractName: payload.contractName,
    overDueType: payload.overDueType
  }
}

export function setYearsSelected(state, payload) {
  const index = state.years.findIndex(
    (year) => year.value === payload
  )
  if (index !== -1) {
    state.years = state.years.map(res => {
      return {...res, selected: false}
    })
    state.years[index] = {...state.years[index], selected: true}
  }
}

export function setDebtRestructurePolicy(state, payload) {
  state.debtRestructurePolicy = payload;
}

export function setDebtRestructurePolicies(state, payload) {
  state.debtRestructurePolicies = payload;
}

export function setDebtRestructurePolicyOptions(state, payload) {
  state.debtRestructurePolicyOptions = payload;
}

export function delDebtRestructurePolicy(state, payload) {
  const policies = state.debtRestructurePolicies.filter(res => res.id !== payload.id);
  state.debtRestructurePolicies = policies || [];
}

export function setMeasure(state, payload) {
  state.measure = payload;
}

export function setMeasures(state, payload) {
  state.measures = payload;
}

export function setMeasureOptions(state, payload) {
  state.measureOptions = payload;
}

export function delMeasure(state, payload) {
  const measures = state.measures.filter(res => res.id !== payload.id);
  state.measures = measures || [];
}

export function setSubMeasure(state, payload) {
  state.subMeasure = payload;
}

export function setSubMeasures(state, payload) {
  state.subMeasures = payload;
}

export function setSubMeasureOptions(state, payload) {
  state.subMeasureOptions = payload;
}

export function delSubMeasure(state, payload) {
  const subMeasures = state.subMeasures.filter(res => res.id !== payload.id);
  state.subMeasures = subMeasures || [];
}
